import { EditOutlined } from "@ant-design/icons";
import { makeIconButton } from "../../icons/utils";

export const EditIconButton = makeIconButton(
  <EditOutlined className="icon-primary" />,
  "Edit",
);
